export const name = 'rnApplicationView';

/**
 * @ngdoc service
 * @name rhino.components.application.service:rnApplicationView
 * @description
 * Simple service for retrieving application views.  This service is useful in an application's
 * main controller to determine which views the user can see in the nav menu.
 */
export default function rnApplicationView($log, rnHttp, rnApplication, $q) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const APPLICATIONS_SEGMENT = 'apps';
  const PORTAL_SERVICE = 'portal_service';

  var service = {
    getAppViews: getAppViews,
    hasView: hasView
  };

  return service;

  ////////////////

  /**
   * @ngdoc function
   * @name getAppViews
   * @methodOf rhino.components.application.service:rnApplicationView
   * @description Retrieve views for a specified application.
   * @param {string} [appId=Current App Id] the application to find views for or the current application if not specified
   * @param {boolean} [reload] true to force a reload of the data from the server
   * @returns {Promise} an array of views or an error response
   */
  function getAppViews(appId, reload) {
    if(!appId) {
      appId = rnApplication.getCurrentAppId();
      if(!appId) {
        return $q.reject('Unable to get the current app id');
      }
    }

    return rnHttp.get(PORTAL_SERVICE, `${APPLICATIONS_SEGMENT}/${appId}/views`, {cache: !reload})
      .then(function(response) {
        return response.data.views;
      });
  }

  /**
   * @ngdoc function
   * @name hasView
   * @methodOf rhino.components.application.service:rnApplicationView
   * @description Determines whether or not a view is present in the list of an application's views.
   * @param {string} [toState] the state to search for
   * @param {string} [appId=Current App Id] the application to find views for or the current application if not specified
   * @param {boolean} [reload] true to force a reload of the data from the server
   * @returns {boolean} true if present, else false
   */
  function hasView(toState, appId, reload) {
    return getAppViews(appId, reload)
      .then(views => {
        let view = _.find(views, v => {
          if (v.state === toState) {
            return true;
          }

          if (v.views) { // We can have, potentially, one level of nested views
            let nestedView = _.find(v.views, nView => {
              return nView.state === toState;
            });

            return nestedView ? true : false;
          }
        });
        return view ? true : false;
      });
  }
}
